import { FormEvent, useState } from 'react';
import { Button, ErrorText, Field, Input } from '../components/ui';
import { login } from '../lib/api';

/** Entrada: painel com a marca (degradê da logo) e o formulário ao lado. */
export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex h-full">
      <div className="bg-brand-gradient relative hidden flex-1 flex-col justify-between overflow-hidden p-10 text-white md:flex">
        <img src="/brand/logo-horizontal-branco.png" alt="AIO Soluções" className="h-10 w-auto self-start" />
        <img src="/brand/simbolo-branco.png" alt="" aria-hidden className="pointer-events-none absolute -right-24 -bottom-24 w-[28rem] opacity-10" />
        <div className="relative max-w-md">
          <h2 className="mb-2 text-3xl font-bold" style={{ fontFamily: 'var(--font-brand)' }}>
            Central de atendimento
          </h2>
          <p className="text-white/80">WhatsApp e Agidesk no mesmo lugar: cada conversa vinculada a um chamado, com o tempo de atendimento medido de verdade.</p>
        </div>
        <span className="relative text-xs text-white/60">AIO Soluções</span>
      </div>

      <div className="flex flex-1 items-center justify-center p-6 md:max-w-xl">
        <form onSubmit={submit} className="w-full max-w-sm">
          <img src="/brand/simbolo.png" alt="AIO Soluções" className="mb-6 size-14 md:hidden" />
          <h1 className="mb-1 text-2xl font-semibold" style={{ fontFamily: 'var(--font-brand)' }}>
            Entrar
          </h1>
          <p className="mb-6 text-sm text-fg-soft">Use seu usuário da plataforma de atendimento.</p>
          <Field label="E-mail">
            <Input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
          </Field>
          <Field label="Senha">
            <Input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </Field>
          <ErrorText error={error} />
          <Button type="submit" variant="primary" className="mt-3 h-10 w-full" loading={loading}>
            Entrar
          </Button>
        </form>
      </div>
    </div>
  );
}
